module.exports = __webpack_public_path__ + "fontawesome-webfont.b06871f281fee6b241d6.ttf";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = ../../../../../src/scss/icons/font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0
// module chunks = styles